import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Trade } from 'src/app/pages/allocation/models/trade';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  private currentTradeMessageSubject = new BehaviorSubject<Trade>(null);
  public currentTrade$ = this.currentTradeMessageSubject.asObservable();

  private riaIdMessageSubject= new BehaviorSubject<number>(null);
  public currentRiaId$ = this.riaIdMessageSubject.asObservable();

  constructor() { }

  allocationDetail(trade: Trade) {
    this.currentTradeMessageSubject.next(trade)
  }

  updateRiaId(riaId: number) {
    this.riaIdMessageSubject.next(riaId)
  }
}